import { t } from '../../i18n.es.js';
import React, { useState, useEffect } from 'react';
import { calculateTimeDelta } from '../../helpers/time.es.js';
import { styled, Caption } from '@teko/ds-desktop';
import { getComponentSize } from '../../helpers/index.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const SIZE = {
  s: {
    level: 3
  },
  m: {
    level: 1
  }
};
const CountdownTime = (_a) => {
  var _b = _a, {
    endAt
  } = _b, others = __objRest(_b, [
    "endAt"
  ]);
  const { isMobile } = useDevice();
  const size = getComponentSize(isMobile);
  const [duration, setDuration] = useState(calculateTimeDelta(new Date(), endAt));
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (duration.milliseconds !== 0) {
        setDuration(calculateTimeDelta(new Date(), endAt));
      }
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const displayCountdown = () => {
    if (duration.days !== 0) {
      return t("C\xF2n {{DurationDays}} ng\xE0y", { DurationDays: duration.days });
    }
    return `${addPaddingNumber(duration.hours)}:${addPaddingNumber(duration.minutes)}:${addPaddingNumber(duration.seconds)}`;
  };
  return /* @__PURE__ */ React.createElement(Timer, __spreadValues({
    level: SIZE[size].level,
    weight: "bold",
    color: "white"
  }, others), displayCountdown());
};
const Timer = styled(Caption)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export { CountdownTime };
